import { Col, Row } from 'react-bootstrap';
import SettingsNav from './SettingsNav';
import { Outlet } from 'react-router-dom';

const SettingsPage = () => {
  return (
    <Row className="g-4 mb-6">
      <Col xs={12} lg="auto">
        <SettingsNav />
      </Col>
      <Col xs={12} lg style={{ minWidth: 0 }}>
        <Outlet />
      </Col>
    </Row>
  );
};

export default SettingsPage;
